import { clearRefinements as algoliaClearRefinements } from 'instantsearch.js/es/widgets';

export const clearRefinements = ({ container }) =>
  algoliaClearRefinements({
    container: container,
    includedAttributes: ['query', 'presence', '_tags', 'skills', 'duration_kind'],
    cssClasses: {
      button: `text-sm text-primary-500 underline disabled:text-gray-500 disabled:opacity-25`,
    },
    templates: {
      resetLabel: 'Clear filters',
    },
  });
